/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { Card, Col, Row, Typography } from "antd";
import { RightOutlined } from "@ant-design/icons";
import Paragraph from "antd/lib/typography/Paragraph";
import EChart from "../Chart/EChart";
import LineChart from "../Chart/LineChart";
import {
  AddRoleIcon,
  AddSchoolIcon,
  AddSubjectIcon,
  AddUserIcon,
  ChartCol,
  Title,
} from "./Dashboard.styles";
import { Link } from "react-router-dom";
import { useGetAllUsersMutation } from "../../common/services/users";
import { useSelector } from "react-redux";
import { useGetAllSchoolsMutation } from "../../common/services/schools";
import { useGetAllStudentsQuery } from "../../common/services/student";
import { useGetAllRolesMutation } from "../../common/services/roles";

const Dashboard = () => {
  const user = useSelector((state) => state.userDetails);

  const { Text } = Typography;
  const [getAllUsers, { data: userData }] = useGetAllUsersMutation();

  useEffect(() => {
    getAllUsers({ schoolId: user?.school?._id }); // or omit schoolId for global count
  }, []);

  const userCount = userData?.Users?.length || 0;

    const [getAllSchools, { data, isLoading, error }] =useGetAllSchoolsMutation()


   const schoolCount = data?.schools.length || 0;

 const { data:studendData } = useGetAllStudentsQuery(
    user?.school?._id,
    { refetchOnMountOrArgChange: true }
  );

   const studentCount = studendData?.students.length || 0



    const [getAllActiveRoles, { data:roleData }] =useGetAllRolesMutation();

   const roleCount = roleData?.roles.length || 0


    useEffect(() => {
    getAllSchools();
    getAllActiveRoles()
  }, []);
  const count = [
    {
      today: "Users",
      title: userCount,
      icon: <AddUserIcon />,
      route: "/user", // Add route path
    },
    {
      today: "Schools",
      title: schoolCount,
      icon: <AddSchoolIcon />,
      route: "/school", // Add route path
    },
    {
      today: "student",
      title: studentCount,
      icon: <AddSubjectIcon />,
      route: "/student", // Add route path
    },
    {
      today: "Roles",
      title: roleCount,
      icon: <AddRoleIcon />,
      route: "/role", // Add route path
    },
  ];

  return (
    <>
      <div>
        <Row gutter={[24, 0]}>
          {count.map((c, index) => (
            <Col key={index} xs={24} sm={24} md={12} lg={6} xl={6}>
              <Card bordered={false}>
                <div>
                  <Row align="middle" gutter={[24, 0]}>
                    <Col xs={16}>
                      <span>{c.today}</span>
                      <Title>{c.title}</Title>
                    </Col>
                    <Col xs={6}>
                      <Link to={c.route}>{c.icon}</Link>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        <Row gutter={[24, 0]}>
          <ChartCol xs={24} sm={24} md={12} lg={12} xl={10}>
            <Card bordered={false}>
              <EChart />
            </Card>
          </ChartCol>
          <ChartCol xs={24} sm={24} md={12} lg={12} xl={14}>
            <Card bordered={false}>
              <LineChart />
            </Card>
          </ChartCol>
        </Row>

        <Row gutter={[24, 0]}>
          <Col xs={24} md={12} sm={24} lg={12} xl={14}>
            <Card bordered={false}>
              <Row gutter>
                <Col xs={24} md={12} sm={24} lg={12} xl={14}>
                  {/* <div>
                    <div>
                      <Text>Upcoming events</Text>
                      <Title level={5}>
                        The standard Lorem Ipsum passage, used since the 1500s
                      </Title>
                      <Paragraph>
                        Contrary to popular belief, Lorem Ipsum is not simply
                        random text. It has roots in a piece of classical Latin
                        literature
                      </Paragraph>
                    </div>
                    <div>
                      <Link to="/">
                        Read More
                        {<RightOutlined />}
                      </Link>
                    </div>
                  </div> */}
                </Col>
                <Col xs={24} md={12} sm={24} lg={12} xl={10}>
                  <div>{/* <img src={card} alt="" /> */}</div>
                </Col>
              </Row>
            </Card>
          </Col>

          {/* <Col xs={24} md={12} sm={24} lg={12} xl={10}>
            <Card bordered={false}>
              <div>
                <div>
                  <Title level={5}>Work with the best</Title>
                  <p>
                    Wealth creation is an evolutionarily recent positive-sum
                    game. It is all about who take the opportunity first.
                  </p>
                </div>
                <div>
                  <Link to="/">
                    Read More
                    <RightOutlined />
                  </Link>
                </div>
              </div>
            </Card>
          </Col> */}
        </Row>
      </div>
    </>
  );
};

export default Dashboard;

